/**
 * Use when httpClient is expected to return just a string/variable and not json
 */
export const TextResonse = {responseType: 'text' as 'json'};